<template>
  <div>
    <DxPopup
      :visible="isVisible"
      :hide-on-outside-click="false"
      :drag-enabled="false"
      :title="title"
      :width="'75%'"
      :height="307"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
      :onHiding="onHiding"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="185"
          :isNormal="true"
          :data-model="formDataModel"
          :formMode="'create'"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          :ref="'add-item-popup-form'"
        ></gc-form>
      </div>

      <div class="footer modal-popup-footer-action-container">
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="cancelPaymentCreation"
        />
        <DxButton
          text="Create"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="createPayment()"
          :disabled="this.createDisabled()"
          :ref="'footer-save-btn'"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { CustomerReceiptService } from "../_services/api/customers/customer-receipt-service";
import { CustomerService } from "../_services/api/customers/customer.service";
import { getFactorByCode } from "../_store/helpers";
import { ForeignCurrencyService } from "../_services/api/settings/accounting/foreign-currency.service";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: function () {},
    },
    customerName: {
      type: String,
      default: "",
    },
    customerCode: {
      type: String,
      default: "",
    },
    salesOrderCode: {
      type: Number,
      default: undefined,
    },
    reference: {
      type: String,
      default: undefined,
    },
    orderAmount: {
      type: Number,
      default: undefined,
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      customerDataLoaded: false,
      exchangeDataLoaded: false,
      paymentMethodDataLoaded: false,
      bankAccountDataLoaded: false,
      salesOrderDataLoaded: false,
      Currency: undefined,
      formDataModel: {
        Date: new Date(),
        AccountingPeriodCode: undefined,
        PaymentMethod: undefined,
        BankAccount: undefined,
        Reference: undefined,
        Customer: undefined,
        Payer: undefined,
        Currency: undefined,
        ExchangeRate: 1.0,
        OrderAmount: 0.0,
        OrderBalance: 0.0,
        Payment: 0,
      },
      PaymentMaxDate: undefined,
      PaymentMinDate: new Date(),
    };
  },
  async mounted() {
    this.setLoading(true);
    await this.$store.dispatch("screenFactors/getFactors", [237]);
    this.formDataModel.Customer = this.customerName;
    this.formDataModel.Payer = this.customerName;
    this.formDataModel.OrderAmount = this.orderAmount;
    await SalesOrderService.getSalesOrderBalanceByCode(
      this.salesOrderCode
    ).then((salesOrderBalanceData) => {
      this.formDataModel.OrderBalance =
        salesOrderBalanceData.SalesOrderTotal -
        salesOrderBalanceData.PaidAmount;
      this.salesOrderDataLoaded = true;
    });

    await CustomerService.getByCode(this.customerCode)
      .then((customerDetails) => {
        customerDetails = customerDetails.data.value[0];
        this.formDataModel.Currency = customerDetails.CurrencyCode;
        this.Currency = customerDetails.CurrencyCode;
        this.customerDataLoaded = true;
      })
      .catch(() => {
        this.setLoading(false);
        this.callback(false);
      });

    if (this.formDataModel.Currency) {
      await ForeignCurrencyService.getByCode(this.formDataModel.Currency)
        .then((res) => {
          this.formDataModel.ExchangeRate = res.data.value[0].BuyRate;
          this.exchangeDataLoaded = true;
        })
        .catch(() => {
          this.setLoading(false);
          this.callback(false);
        });
    } else {
      this.exchangeDataLoaded = true;
    }

    await CustomerReceiptService.getPaymentMethods()
      .then(({ data }) => {
        this.formDataModel.PaymentMethod = data.value.filter(
          (val) => val.isDefault === 1
        )[0].PayType;
        this.paymentMethodDataLoaded = true;
      })
      .catch(() => {
        this.setLoading(false);
        this.callback(false);
      });

    this.formDataModel.BankAccount = `${getFactorByCode(237).FactorInt}`;
    this.bankAccountDataLoaded = true;

    this.setLoading(false);

    this.initialized();
  },
  methods: {
    onHiding() {
      this.callback(false);
    },
    cancelPaymentCreation() {
      this.callback(false);
    },
    async createPayment() {
      this.setLoading(true);
      await CustomerReceiptService.saveCashinUASalesOrder({
        SalesOrderCode: this.salesOrderCode,
        DateIn: this.formDataModel.Date,
        Amount: this.formDataModel.Payment,
        WebOrderNo: undefined,
        BankAccount: parseInt(this.formDataModel.BankAccount),
        PaymentMethod: this.formDataModel.PaymentMethod,
        Reference: this.formDataModel.Reference || "",
        PayerName: this.formDataModel.Payer,
        ExchangeRate: this.formDataModel.ExchangeRate,
      })
        .then(() => {
          this.callback(true, this.salesOrderCode);
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    DateChanged({ value }) {
      this.formDataModel.Date = value;
    },
    async initialized() {
      await CustomerReceiptService.getCurrentAccountingPeriodCode()
        .then(({ data }) => {
          this.formDataModel.AccountingPeriodCode =
            data.value[0].AccountingPeriodCode;
          CustomerReceiptService.getCurrentAccountingPeriod(
            data.value[0].AccountingPeriodCode
          )
            .then(({ data }) => {
              this.formDataModel.minDate = data.value[0].DateStart;
            })
            .catch();
        })
        .catch();

      this.setDateValidation();
      this.formDataModel.Date = new Date();
    },
    async setDateValidation() {
      var currentPaymentDate = undefined;

      currentPaymentDate = this.PaymentMinDate;

      let startDateResult =
        await CustomerReceiptService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriodStartDate = new Date(
          startDateResult.data.value[0].StartDate.replace("Z", "")
        );

        this.PaymentMinDate = accountingPeriodStartDate;
      } else {
        this.PaymentMinDate = currentPaymentDate;
      }

      let endDateResult =
        await CustomerReceiptService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriodEndDate = endDateResult.data.value[0].EndDate;
        this.PaymentMaxDate = new Date(
          accountingPeriodEndDate.replace("Z", "")
        );
      }
    },

    createDisabled() {
      let paymentMethodNotSet = this.formDataModel.PaymentMethod == undefined;
      let bankAccountNotSet = this.formDataModel.BankAccount == undefined;
      let invalidPayment = this.formDataModel.Payment == 0;
      return paymentMethodNotSet || bankAccountNotSet || invalidPayment;
    },
  },
  computed: {
    isVisible() {
      return (
        this.visible &&
        this.customerDataLoaded &&
        this.exchangeDataLoaded &&
        this.paymentMethodDataLoaded &&
        this.bankAccountDataLoaded &&
        this.salesOrderDataLoaded
      );
    },
    title() {
      return `Create Payment for Sales Order #${this.salesOrderCode}`;
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Date",
                  dataField: "Date",
                  editorOptions: {
                    min: this.PaymentMinDate,
                    max: this.PaymentMaxDate,

                    onValueChanged: (e) => {
                      this.DateChanged(e);
                    },
                  },
                  label: {
                    text: "Date",
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Date is required",
                    },
                  ],
                },
                {
                  screenField: "PaymentMethod",
                  dataField: "PaymentMethod",
                },
                {
                  screenField: "BankAccount",
                  dataField: "BankAccount",
                },
                {
                  screenField: "Reference",
                  dataField: "Reference",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "Customer",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  label: {
                    Text: "Customer",
                  },
                },
                {
                  screenField: "Payer",
                  dataField: "Payer",
                  allowUpdate: true,
                  label: {
                    text: "Payer",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "Currency",
                  allowUpdate: false,
                  label: {
                    text: "Currency",
                  },
                },
                {
                  screenField: "ExchangeRate",
                  dataField: "ExchangeRate",
                  editorOptions: {
                    allowUpdate: this.Currency != "AUD",
                  },
                },
                {
                  screenField: "FXAmount",
                  dataField: "OrderAmount",
                  label: {
                    text: `Order Amount (${this.Currency})`,
                  },
                  editorOptions: {
                    allowUpdate: false,
                  },
                },
                {
                  screenField: "FXAmount",
                  dataField: "OrderBalance",
                  label: {
                    text: `Order Balance (${this.Currency})`,
                  },
                  editorOptions: {
                    allowUpdate: false,
                  },
                },
                {
                  screenField: "FXAmount",
                  dataField: "Payment",
                  label: {
                    text: `Payment (${this.Currency})`,
                  },
                  editorOptions: {
                    max: this.formDataModel.OrderBalance,
                    min: 0,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.modal-popup-footer-action-container {
  padding-top: 10px;
  bottom: 0;
  margin-right: 0px;
  height: 45px;
  text-align: right;

  .save-btn {
    margin-right: 0px;
    background-color: #8bc34a;
  }

  .cancel-btn {
    margin-right: 10px;
    background-color: #ff0033;
  }
}
</style>
